import { c as _c } from "react/compiler-runtime";
import { Button } from '@7f-ui/components/button/button';
import type { AccommodationFragment } from 'src/lib/backend/documents/accommodation';
import { AccommodationReviewCards } from './review-cards';
import { AccommodationReviewScores } from './review-scores';
type Reviews = AccommodationFragment['reviews'];
type ReviewScores = AccommodationFragment['reviewScores'];
type AccommodationReviewSectionProps = {
  reviews: Reviews;
  reviewScores: ReviewScores;
  onSeeAll: (id?: string) => void;
};
const MAX_REVIEWS = 3;
export function AccommodationReviewSection(t0) {
  const $ = _c(14);
  const {
    reviews,
    reviewScores,
    onSeeAll
  } = t0;
  let t1;
  if ($[0] !== reviewScores) {
    t1 = <AccommodationReviewScores reviewScores={reviewScores} />;
    $[0] = reviewScores;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== reviews) {
    t2 = reviews.slice(0, MAX_REVIEWS);
    $[2] = reviews;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== onSeeAll || $[5] !== t2) {
    t3 = <AccommodationReviewCards reviews={t2} onReadMore={onSeeAll} />;
    $[4] = onSeeAll;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== onSeeAll || $[8] !== reviews.length) {
    t4 = reviews.length > MAX_REVIEWS && <div><Button variant="secondary" onClick={() => onSeeAll()} width="responsive">Alle Bewertungen</Button></div>;
    $[7] = onSeeAll;
    $[8] = reviews.length;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== t1 || $[11] !== t3 || $[12] !== t4) {
    t5 = <div className="flex flex-col gap-6">{t1}{t3}{t4}</div>;
    $[10] = t1;
    $[11] = t3;
    $[12] = t4;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  return t5;
}